import { createSignal, onMount, Show } from 'solid-js';

import { multiagent } from '~/api/globals/agent';
import { completeOAuthCallback } from '~/api/globals/oauth';

import CircularProgress from '~/com/components/CircularProgress';

/**
 * Rendered when the app boots on the OAuth redirect URI (`/oauth/callback`).
 * Completes the token exchange, registers the account, then returns home.
 */
const OAuthCallback = () => {
	const [error, setError] = createSignal<string>();

	onMount(async () => {
		try {
			const session = await completeOAuthCallback();
			const did = await multiagent.addOAuthAccount(session);

			multiagent.active = did;

			// Replace history so the callback URL (with the code in it) isn't
			// reachable via back navigation.
			location.replace('/');
		} catch (err) {
			setError('' + ((err as any)?.message ?? err));
		}
	});

	return (
		<div class="flex h-screen w-screen flex-col items-center justify-center gap-4 p-6 text-center">
			<Show
				when={error()}
				fallback={
					<>
						<CircularProgress />
						<p class="text-sm text-muted-fg">Signing you in…</p>
					</>
				}
			>
				{(message) => (
					<>
						<h1 class="text-lg font-bold">Sign in failed</h1>
						<p class="max-w-sm break-words text-sm text-muted-fg">{message()}</p>
						<a href="/" class="text-sm text-accent hover:underline">
							Return home
						</a>
					</>
				)}
			</Show>
		</div>
	);
};

export default OAuthCallback;
